import React, { useState } from 'react'
import {
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	TextField,
	Snackbar,
	Alert,
	IconButton,
	CircularProgress
} from '@material-ui/core'
import axios from 'axios'
import iziToast from 'izitoast'
import { makeStyles } from '@material-ui/core/styles'
import { Close, Add as PlusIcon } from '@material-ui/icons'
import { useStoreon } from 'storeon/react'

interface AddSectionModalProps {
	onSuccess?: () => void
}

const useStyles = makeStyles(() => ({
	dialogTitle: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		paddingRight: '16px'
	}
}))

const SectionsAdd: React.FC<AddSectionModalProps> = ({ onSuccess }) => {
	const [open, setOpen] = useState(false)
	const [sectionName, setSectionName] = useState('')
	const [sectionDescription, setSectionDescription] = useState('')
	const [snackbarOpen, setSnackbarOpen] = useState(false)
	const [loading, setLoading] = useState(false)

	const classes = useStyles()
	const { token } = useStoreon('token')

	const handleClose = () => setOpen(false)
	const handleOpen = () => setOpen(true)

	const handleCancel = () => {
		setSectionName('')
		setSectionDescription('')
	}

	const handleSave = async () => {
		setLoading(true)
		try {
			const payload = {
				name: sectionName,
				description: sectionDescription
			}

			const response = await axios.post(
				`${process.env.REACT_APP_API_URL}/api/v1/custom/createSection`,
				payload,
				{
					headers: {
						Authorization: ` ${token}`
					}
				}
			)

			if (response?.data?.message) {
				iziToast.success({
					message: response.data.message || 'Section created successfully!'
				})
				setSectionName('')
				setSectionDescription('')
				setSnackbarOpen(true)
				onSuccess?.()
				handleClose()
			} else {
				iziToast.error({
					message: 'Failed to create section. No message in response.'
				})
			}
		} catch (error) {
			iziToast.error({
				message: 'Failed to create section.'
			})
			console.error('Axios error:', error)
		} finally {
			setLoading(false)
		}
	}

	return (
		<div>
			<Button
				variant="contained"
				sx={{ textTransform: 'none' }}
				color="primary"
				onClick={handleOpen}
			>
				<PlusIcon sx={{ mr: 0.5 }} />
				Add Section
			</Button>

			<Dialog open={open} onClose={handleClose}>
				{/* <DialogTitle
					disableTypography
					className={classes.dialogTitle}
					style={{ backgroundColor: 'rgb(125, 110, 241)', height: '50px', color: 'white' }}
				>
					<h2>Add New Section</h2>
					<IconButton onClick={handleClose}>
						<Close style={{ color: 'white' }} />
					</IconButton>
				</DialogTitle> */}
				<DialogTitle
					disableTypography
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						backgroundColor: 'rgb(125, 110, 241)',
						height: '50px',
						color: 'white',
						padding: '0 16px'
					}}
				>
					<h2 style={{ margin: 0, fontSize: '1.25rem' }}>Add New Section</h2>
					{/* <IconButton onClick={handleClose}> */}
					<Close style={{ color: 'white', cursor: 'pointer' }} onClick={handleClose} />
					{/* </IconButton> */}
				</DialogTitle>

				<DialogContent>
					<TextField
						autoFocus
						margin="dense"
						label="Section Name"
						placeholder="Enter section"
						type="text"
						fullWidth
						value={sectionName}
						onChange={e => setSectionName(e.target.value)}
					/>
					<TextField
						margin="dense"
						label="Description"
						placeholder="Enter description"
						type="text"
						fullWidth
						multiline
						rows={3}
						value={sectionDescription}
						onChange={e => setSectionDescription(e.target.value)}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleCancel} variant="outlined" sx={{ textTransform: 'none' }}>
						Cancel
					</Button>
					<Button
						onClick={handleSave}
						color="primary"
						variant="contained"
						disabled={loading}
						sx={{ textTransform: 'none', minWidth: '100px' }}
					>
						{loading ? 'Creating...' : 'Create'}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	)
}

export default SectionsAdd
